module.exports = __webpack_public_path__ + "img/icon_证书_E级赛事@2x.1e26f8cd.png";